/**
 * Combine Tailwind CSS classes with conditional logic.
 * Prevents `false | null | undefined` from being included in the resulting string.
 */
export const cn = (...parts: Array<string | false | null | undefined>) => parts.filter(Boolean).join(' ');
